import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router } from '@angular/router';
import { LocalStorageService } from '@services/local-storage.service';
import { AuthguradServiceService as AuthGuardService } from './authgurad-service.service';
import { ILoggedInUserViewModel } from './model/common.model';

@Injectable({
  providedIn: 'root',
})
export class AuthenticationGuard implements CanActivate {
  constructor(private AuthGuardService: AuthGuardService, private router: Router, private readonly localStorageService: LocalStorageService) {}

  canActivate(route: ActivatedRouteSnapshot): boolean {
    // kept the logic that was originally implemented by the Interbiz team
    const user: ILoggedInUserViewModel = this.localStorageService.getCurrentUserDetails();
    const role = user?.role;
    const isRoleAccess = route.data.role.includes(role);

    if (!this.localStorageService.getAccessToken()) {
      debugger;
      this.localStorageService.onLogout();
      void this.router.navigateByUrl('/login');
    } else if (!isRoleAccess) {
      this.localStorageService.onLogout();
      debugger;
      this.AuthGuardService.isRoleAllow.next(null);
      this.router.navigateByUrl("/login");
    }
    return this.AuthGuardService.gettoken();
  }
}
